import React from 'react';
import { Card } from 'antd';
// import * as parse from 'url-parse';
import Request from '../../model/Request';

import { Item } from '../Views/Item';
import DNSSECAccreditationIcon from '../icons/DNSSECAccreditationIcon';
import AccreditationIcon from '../icons/AccreditationIcon';
import Tooltip from 'antd/es/tooltip';
// import EventStatusIcon from '../icons/EventStatusIcon';
import EventStatusIcon from '../icons/EventStatusIcon';
import { calcFontSize } from '../Common';
import Flex from '../StyledComponents/Flex';
import { useTranslation } from '@nic-react-i18n/core';
import { isNullOrUndefined } from '../../utils';
import { useNavigate } from 'react-router';
import TestType from '../../model/TestType';
import dayjs from 'dayjs';

export interface Test {
    version: string;
    type: string;
}

interface RequestPropsInterface {
    request: Request;
    test: TestType;
    expanded: boolean;
    width?: number;
    height?: number;
}

type SimpleRequestViewProps = RequestPropsInterface

const SimpleRequestView: React.FC<SimpleRequestViewProps> = (props)  => {

    const {t} = useTranslation()

    const navigate = useNavigate()
/*
    const renderTestDetails = (test: Test) => {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <span
                    style={{
                        fontWeight: 700,
                        fontSize: 'larger'
                    }}
                >
                    {t('requests.header.test')}
                </span>
                <span>
                    {t(`test.${test.type}`)}
                </span>
                <Avatar>
                    {test.version}
                </Avatar>

            </div>
        );
    }

    const evaluateStatus = (request: Request) => {
        let status: string = 'pending';
        if (!isNullOrUndefined(request.succededDate)) {
            status = 'succeeded';
        } else {
            if (request.bookings && request.bookings.bookings.length < request.maxTests ) {
                status = 'pending';
            } else {
                status = 'failed';
            }
        }
        return status;
    }
*/
    const renderRequestDetail = (request: Request) => {
        const {test, width} = props;
        let icon ;
        // console.log('width: ', window.innerWidth);
        let size = calcFontSize(window.innerWidth);
        let fontSize = `${size.fontSize}vw`;
        let iconSize = `${size.iconSize}vw`;
        if (test.type === 'dnssec') {
            icon = <DNSSECAccreditationIcon size={iconSize}/>;
        } else {
            icon = <AccreditationIcon size={iconSize} color={'orange'}/>;
        }
        const value = (width ?? 46 ) - 20;

        return (
            <Flex
                direction={'row'}
                wrap={'wrap'}
                justify={'space-between'}
                align={'center'}
                style={{
                    width: '100%'
                }}

            >
                {icon}

                <Flex
                    direction={'column'}
                    align={'flex-start'}
                    style={{
                        width: `${value}vw`,
                        fontSize: fontSize
                    }}
                >
                        <span
                            style={{
                                fontWeight: 700,
                                fontSize: 'larger'
                            }}
                        >
                            {request.registrar}
                        </span>

                    <div style={{color: '#9e9e9e', fontWeight: 800, fontSize: fontSize}}>
                        {t(`requests.header.request.${test.type}`)}
                    </div>

                    <Item
                        style={{textTransform: 'capitalize'}}
                        label={t('request.creationDate')}
                        value={dayjs(request.created)}
                    />

                    {
                        !isNullOrUndefined(request.endDate) &&

                        <Item
                            style={{textTransform: 'capitalize'}}
                            label={t('request.endDate')}
                            value={dayjs(request.endDate)}
                        />

                    }
                    {request.succededDate &&
                        <Item
                            style={{textTransform: 'capitalize'}}
                            label={t('request.succededDate')}
                            value={request.succededDate && dayjs(request.succededDate)}
                        />
                    }
                    {request.deleted &&
                    <Item
                        style={{textTransform: 'capitalize'}}
                        label={t('request.deletedDate')}
                        value={request.deleted && dayjs(request.deleted)}
                    />
                    }

                </Flex>
                <div
                    style={{
                        fontSize: iconSize
                    }}
                >
                    <EventStatusIcon status={request.status}/>
                </div>
            </Flex>
        );
    }


        const { request, test, height } = props;

    // console.log('SimpleRequestView: ', request, test)

        let requestContent = renderRequestDetail(request);
        // let testContent = this.renderTestDetails(test);
        const heightValue = height ?? 20 ;
        return (
            <Card>
                <Tooltip
                    title={t(`tooltip.${test.type}.request`, {reg: request.registrar})}
                >
                <Flex
                    direction={'row'}
                    wrap={'wrap'}
                    align={'center'}
                    justify={'space-between'}
                    style={{
                        cursor: 'pointer',
                        width: '100%',
                        height:  `${heightValue}vh`,
                    }}
                    onClick={() => {
                        let newUrl = `/requests/${request.id}`;
                        navigate(newUrl)
                    }}
                >
                    {requestContent}
                </Flex>
                </Tooltip>
            </Card>
        )

}
export default SimpleRequestView